/**
 * UTM-Übernahme in die Warenkorbattribute.
 *
 * Warum das kein Beiwerk ist: es gibt keinen Pixel auf der Hauptdomain,
 * also auch keine Plattform-Attribution, die einspringen könnte. Die
 * Bestelldaten sind bei unseren Mengen die einzige Wahrheitsquelle
 * (Spec Abschnitt 4.3 und 10, Regel 2). Ohne diese Datei ist keine
 * Bestellung einer Quelle zuzuordnen.
 *
 * Ablauf:
 * 1. Beim ersten Aufruf werden utm_source, utm_medium, utm_campaign,
 *    utm_content und utm_term aus der Adresse gelesen und in
 *    sessionStorage gelegt. Spätere Seiten überschreiben sie nicht:
 *    die erste Quelle einer Sitzung ist die, die gezählt wird.
 * 2. Die drei Klick-Kennungen gclid, fbclid und msclkid getrennt davon,
 *    und nur mit Einwilligung in Marketing, siehe unten.
 * 3. window.ffUtm() gibt die gemerkten Werte als Objekt zurück, die
 *    Klick-Kennungen nur, solange die Einwilligung besteht.
 * 4. Beim Absenden jeder Form mit action="/cart/add" wandern sie als
 *    versteckte attributes[...]-Felder mit, unter ihrem eigenen Namen.
 * 5. Auf /cart werden sie über POST /cart/update.js nachgetragen, falls
 *    sie dort noch fehlen. Das fängt den Fall ab, dass die erste
 *    Position vor dem Laden dieser Datei im Korb lag. Ohne Einwilligung
 *    werden dort Klick-Kennungen aus einer früheren Einwilligung
 *    wieder entfernt.
 *
 * Grenzen, bewusst:
 * - Kein Fremdabruf. Nur Adressen dieses Shops. Die Einwilligung kommt
 *   aus Shopifys eigener Customer Privacy API.
 * - Kein personenbezogenes Datum. Name, Zielzeit und Rennen sind
 *   Bestelldaten und bleiben in Shopify (Spec 10, Regel 1).
 * - Kein Cookie. sessionStorage endet mit dem Tab, das ist für die
 *   Zuordnung einer Sitzung genau richtig.
 *
 * Klick-Kennungen (Tracking-Audit 19.09.2026, Code-Review 25.09.2026,
 * H4): die Hauptdomain nimmt gclid, fbclid und msclkid im
 * Anmeldeformular mit. Ohne sie gibt es später keinen Abgleich einer
 * Bestellung mit dem Klick bei Meta oder Google. Eine Klick-Kennung ist
 * aber eine Kennung für genau diesen Klick, also nur mit Einwilligung:
 * gelesen, gespeichert und an die Bestellung geschrieben wird sie erst,
 * wenn window.Shopify.customerPrivacy.marketingAllowed() wahr ist
 * (Cookie-Banner von Shopify, ENT-081). Ohne Einwilligung wird sie
 * verworfen, nicht aufgehoben: kein Speicher, kein Attribut. Kommt die
 * Einwilligung später auf derselben Seite (Ereignis
 * visitorConsentCollected), wird die Adresse dieser Seite noch einmal
 * gelesen. Wird sie widerrufen, fliegen Speicher und Warenkorbattribute.
 *
 * Offen, gehört ins Anwaltsmandat: auch die UTM-Werte liegen im
 * sessionStorage, und § 25 TDDDG fragt nicht nach der Technik. Sie
 * bleiben ohne Einwilligung, weil sie keine Kennung tragen, sondern nur
 * die Kampagne nennen (Marvin, 25.09.2026, im Auftrag zum Code-Review).
 * Ob das trägt, ist weiter zu klären. Steht in docs/MESSUNG.md,
 * Abschnitt 3.1.
 */
(function () {
  'use strict';

  var SCHLUESSEL = 'ff-utm';
  var SCHLUESSEL_KLICK = 'ff-klick';
  var FELDER = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var KLICK = ['gclid', 'fbclid', 'msclkid'];

  /* sessionStorage kann werfen: privates Fenster, gesperrte Website-Daten.
     Beides ist kein Grund, die Seite zu beschädigen. */
  function lesenAusSpeicher(schluessel) {
    try {
      var roh = window.sessionStorage.getItem(schluessel);
      return roh ? JSON.parse(roh) : null;
    } catch (fehler) {
      return null;
    }
  }

  function schreibenInSpeicher(schluessel, werte) {
    try {
      window.sessionStorage.setItem(schluessel, JSON.stringify(werte));
    } catch (fehler) {
      /* Ohne Speicher gilt nur die aktuelle Seite. Besser als nichts. */
    }
  }

  function entfernenAusSpeicher(schluessel) {
    try {
      window.sessionStorage.removeItem(schluessel);
    } catch (fehler) {
      /* Was nicht gespeichert werden konnte, ist auch nicht da. */
    }
  }

  function ausAdresse(felder) {
    var gefunden = {};
    var such;

    try {
      such = new URLSearchParams(window.location.search);
    } catch (fehler) {
      return gefunden;
    }

    for (var i = 0; i < felder.length; i++) {
      var wert = such.get(felder[i]);
      if (wert) gefunden[felder[i]] = wert.slice(0, 255);
    }

    return gefunden;
  }

  /* Nur die genannten Felder, alles andere fällt weg. */
  function auswahl(objekt, felder) {
    var aus = {};
    if (!objekt) return aus;
    for (var i = 0; i < felder.length; i++) {
      if (Object.prototype.hasOwnProperty.call(objekt, felder[i]) && objekt[felder[i]]) {
        aus[felder[i]] = String(objekt[felder[i]]);
      }
    }
    return aus;
  }

  function istLeer(objekt) {
    for (var name in objekt) {
      if (Object.prototype.hasOwnProperty.call(objekt, name)) return false;
    }
    return true;
  }

  function kopieren(ziel, quelle) {
    for (var name in quelle) {
      if (Object.prototype.hasOwnProperty.call(quelle, name)) ziel[name] = quelle[name];
    }
    return ziel;
  }

  /* Die erste Quelle einer Sitzung gewinnt. Wer über eine Anzeige kommt
     und danach über die Hauptdomain zurückspringt, bleibt der Anzeige
     zugeordnet.

     Bis zum 25.09.2026 lagen die Klick-Kennungen unter demselben
     Schlüssel wie die UTM-Werte. Ein solcher Altbestand wird hier auf
     die UTM-Werte zurückgeschnitten. */
  var roh = lesenAusSpeicher(SCHLUESSEL);
  var gemerkt = auswahl(roh, FELDER);
  if (roh && !istLeer(auswahl(roh, KLICK))) {
    if (istLeer(gemerkt)) entfernenAusSpeicher(SCHLUESSEL);
    else schreibenInSpeicher(SCHLUESSEL, gemerkt);
  }

  if (istLeer(gemerkt)) {
    gemerkt = ausAdresse(FELDER);
    if (!istLeer(gemerkt)) schreibenInSpeicher(SCHLUESSEL, gemerkt);
  }

  /* ---------- Klick-Kennungen, nur mit Einwilligung ----------
     Bis die Customer Privacy API geantwortet hat, gilt: keine
     Einwilligung. */
  var klickErlaubt = false;
  var klick = {};

  function marketingErlaubt() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.marketingAllowed !== 'function') return false;
    try {
      return api.marketingAllowed() === true;
    } catch (fehler) {
      return false;
    }
  }

  function einwilligungAnwenden(erlaubt) {
    klickErlaubt = erlaubt;
    if (!erlaubt) {
      klick = {};
      entfernenAusSpeicher(SCHLUESSEL_KLICK);
      return;
    }
    klick = auswahl(lesenAusSpeicher(SCHLUESSEL_KLICK), KLICK);
    if (istLeer(klick)) {
      klick = ausAdresse(KLICK);
      if (!istLeer(klick)) schreibenInSpeicher(SCHLUESSEL_KLICK, klick);
    }
  }

  /* Shopify lädt die API erst auf Anforderung. Fehlt loadFeatures
     (Theme-Editor, Blocker), bleibt es bei "keine Einwilligung". */
  function apiLaden(fertig) {
    var shop = window.Shopify;
    if (shop && shop.customerPrivacy && typeof shop.customerPrivacy.marketingAllowed === 'function') {
      fertig();
      return;
    }
    if (shop && typeof shop.loadFeatures === 'function') {
      try {
        shop.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          fertig();
        });
        return;
      } catch (fehler) {
        /* fällt durch */
      }
    }
    fertig();
  }

  window.ffUtm = function () {
    var kopie = kopieren({}, gemerkt);
    if (klickErlaubt) kopieren(kopie, klick);
    return kopie;
  };

  /* ---------- Beim Hinzufügen zum Warenkorb ----------
     Die Felder werden erst beim Absenden gesetzt, nicht beim Laden:
     so nimmt ein Formular, das die Seite nachträglich umbaut, sie
     trotzdem mit. */
  function feldSetzen(form, name, wert) {
    var vorhanden = form.querySelector('input[name="attributes[' + name + ']"]');

    if (!vorhanden) {
      vorhanden = document.createElement('input');
      vorhanden.type = 'hidden';
      vorhanden.name = 'attributes[' + name + ']';
      form.appendChild(vorhanden);
    }

    vorhanden.value = wert;
  }

  function feldEntfernen(form, name) {
    var vorhanden = form.querySelector('input[name="attributes[' + name + ']"]');
    if (vorhanden && vorhanden.parentNode) vorhanden.parentNode.removeChild(vorhanden);
  }

  function istWarenkorbForm(form) {
    var ziel = form.getAttribute('action') || '';
    return ziel.indexOf('/cart/add') !== -1;
  }

  document.addEventListener(
    'submit',
    function (ereignis) {
      var form = ereignis.target;
      if (!form || !form.tagName || form.tagName.toLowerCase() !== 'form') return;
      if (!istWarenkorbForm(form)) return;

      /* Aus einer früheren Absendung derselben Seite (Zurück im Browser)
         kann noch eine Klick-Kennung im Formular stehen. */
      if (!klickErlaubt) {
        for (var k = 0; k < KLICK.length; k++) feldEntfernen(form, KLICK[k]);
      }

      var werte = window.ffUtm();
      for (var name in werte) {
        if (Object.prototype.hasOwnProperty.call(werte, name)) feldSetzen(form, name, werte[name]);
      }
    },
    true
  );

  /* ---------- Auf der Warenkorbseite nachtragen ----------
     Nur, was dort noch fehlt. Ein bereits gesetztes Attribut wird nie
     überschrieben: sonst gewönne die letzte Seite statt der ersten.
     Einzige Ausnahme: ohne Einwilligung werden Klick-Kennungen am
     Warenkorb geleert, ein leerer Wert entfernt das Attribut. */
  function nachtragen(ueberall) {
    if (!window.fetch) return;
    if (!ueberall && window.location.pathname.indexOf('/cart') === -1) return;

    var werte = window.ffUtm();
    var wurzel = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    window
      .fetch(wurzel + 'cart.js', {
        headers: { Accept: 'application/json' }
      })
      .then(function (antwort) {
        return antwort.ok ? antwort.json() : null;
      })
      .then(function (korb) {
        if (!korb) return null;

        var vorhanden = korb.attributes || {};
        var aenderung = {};
        var etwasZuTun = false;

        for (var name in werte) {
          if (!Object.prototype.hasOwnProperty.call(werte, name)) continue;
          if (vorhanden[name]) continue;
          aenderung[name] = werte[name];
          etwasZuTun = true;
        }

        if (!klickErlaubt) {
          for (var k = 0; k < KLICK.length; k++) {
            if (!vorhanden[KLICK[k]]) continue;
            aenderung[KLICK[k]] = '';
            etwasZuTun = true;
          }
        }

        if (!etwasZuTun) return null;

        return window.fetch(wurzel + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: aenderung })
        });
      })
      .catch(function () {
        /* Eine fehlgeschlagene Zuordnung darf den Kauf nie aufhalten. */
      });
  }

  /* Die Wahl im Banner kommt oft erst nach dem Laden. Zustimmung trägt
     die Kennung aus der Adresse dieser Seite nach, ein Widerruf räumt
     Speicher und Warenkorb auf, auf jeder Seite, nicht nur im Korb. */
  document.addEventListener('visitorConsentCollected', function (ereignis) {
    var detail = ereignis && ereignis.detail;
    var erlaubt = detail && typeof detail.marketingAllowed === 'boolean' ? detail.marketingAllowed : marketingErlaubt();
    var vorher = klickErlaubt;
    einwilligungAnwenden(erlaubt);
    if (erlaubt) nachtragen(false);
    else if (vorher) nachtragen(true);
  });

  function starten() {
    apiLaden(function () {
      einwilligungAnwenden(marketingErlaubt());
      nachtragen(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();
